import { useEffect, useRef, useState } from 'react';

import { MultiSelectField } from '@app/components/common';
import { GuideName } from '@app/api/guides';

import { FilterComponentProps } from '../../types';
import { useFetchOptions } from '../../hooks/use-fetch-options';

export function MultiSelectFilter<I extends EntityBase = EntityBase>(props: Pick<FilterComponentProps<I>, 
  'filter' | 'onChange'>) {
  const {
    filter,
    onChange,
  } = props;
  const [options, setOptions] = useState<EntityBase[]>([]);
  const fetch = useFetchOptions(filter.source as GuideName, filter.onOptionsFetch);

  useEffect(() => {
    (async () => {
      const _options = await fetch();
      setOptions(_options);
    })();
  }, []);

  return <MultiSelectField 
    id={filter.name.toString()}
    label={filter.label}
    value={filter.value as EntityBase[] || []}
    options={options}
    onChange={(value) => {
      onChange({
        ...filter,
        value
      });
    } } 
  />;
}

